var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.EntityForm
        ? _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: 12 } }, [
                _c("h3", [_vm._v("Nueva visita")])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: 12 } },
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            show: _vm.alertSaved == 1,
                            variant: "success",
                            dismissible: ""
                          }
                        },
                        [_vm._v("Guardado satisfactoriamente")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-alert",
                        {
                          attrs: {
                            show: _vm.alertSaved == 2,
                            variant: "danger",
                            dismissible: ""
                          }
                        },
                        [_vm._v("Error (GC-GUARDADO)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Entidad:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("multiselect", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      placeholder: "Seleccionar",
                                      "deselect-label":
                                        "Click o enter para deseleccionar",
                                      "select-label":
                                        "Click o enter para seleccionar",
                                      options: _vm.inputs.entity.options,
                                      multiple: false,
                                      "close-on-select": true,
                                      "clear-on-select": true,
                                      "preserve-search": true,
                                      label: "name",
                                      "track-by": "value",
                                      "preselect-first": true,
                                      name: "Entidad"
                                    },
                                    model: {
                                      value: _vm.inputs.entity.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.inputs.entity,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "inputs.entity.value"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.errors.first("Entidad")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 3 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mt-24",
                                  attrs: { id: "inputGroup" }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "lg",
                                        disabled: _vm.disabledOffer,
                                        variant: "default"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.showPublicOffer()
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "p-0 fa fa-eye" }),
                                      _vm._v("  Oferta pública\n              ")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    { on: { click: _vm.sendEmail } },
                                    [
                                      _c("i", { staticClass: "fa fa-plus" }),
                                      _vm._v("  Nueva entidad")
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Distribuidora:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      options: _vm.inputs.distributor.options,
                                      size: "sm",
                                      name: "Distribuidora"
                                    },
                                    model: {
                                      value: _vm.inputs.distributor.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.inputs.distributor,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "inputs.distributor.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Visitador:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "exampleInput1",
                                      disabled: true,
                                      type: "text",
                                      required: "",
                                      placeholder: "",
                                      name: "Visitador"
                                    },
                                    model: {
                                      value: _vm.inputs.visitador,
                                      callback: function($$v) {
                                        _vm.$set(_vm.inputs, "visitador", $$v)
                                      },
                                      expression: "inputs.visitador"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Estado:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      options: _vm.inputs.status.options,
                                      size: "sm",
                                      name: "Estado"
                                    },
                                    model: {
                                      value: _vm.inputs.status.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.inputs.status,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "inputs.status.value"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.errors.first("Estado")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Fecha visita realizada:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("datetime", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.isDoneRequired,
                                            expression: "isDoneRequired"
                                          }
                                        ],
                                        attrs: {
                                          name: "Fecha y hora realizada",
                                          "input-class": "form-control",
                                          phrases: {
                                            ok: "Ok",
                                            cancel: "Cancelar"
                                          },
                                          type: "datetime",
                                          auto: true,
                                          "minute-step": 15,
                                          "value-zone": "local",
                                          "max-datetime": _vm.currentDate,
                                          format: {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: false
                                          },
                                          zone: "local"
                                        },
                                        model: {
                                          value: _vm.inputs.visitedDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.inputs,
                                              "visitedDate",
                                              $$v
                                            )
                                          },
                                          expression: "inputs.visitedDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group-text",
                                        {
                                          attrs: { slot: "append" },
                                          on: {
                                            click: function($event) {
                                              _vm.inputs.visitedDate = ""
                                            }
                                          },
                                          slot: "append"
                                        },
                                        [
                                          _c(
                                            "strong",
                                            { staticClass: "text-danger" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "Fecha y hora realizada"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Fecha visita planificada:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("datetime", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: _vm.isPlanifiedRequired,
                                            expression: "isPlanifiedRequired"
                                          }
                                        ],
                                        attrs: {
                                          name: "Fecha y hora planificada",
                                          "input-class": "form-control",
                                          phrases: {
                                            ok: "Ok",
                                            cancel: "Cancelar"
                                          },
                                          type: "datetime",
                                          auto: true,
                                          "minute-step": 15,
                                          "value-zone": "local",
                                          format: {
                                            year: "numeric",
                                            month: "2-digit",
                                            day: "2-digit",
                                            hour: "numeric",
                                            minute: "2-digit",
                                            hour12: false
                                          },
                                          zone: "local"
                                        },
                                        model: {
                                          value: _vm.inputs.scheduledDate,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.inputs,
                                              "scheduledDate",
                                              $$v
                                            )
                                          },
                                          expression: "inputs.scheduledDate"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-input-group-text",
                                        {
                                          attrs: { slot: "append" },
                                          on: {
                                            click: function($event) {
                                              _vm.inputs.scheduledDate = ""
                                            }
                                          },
                                          slot: "append"
                                        },
                                        [
                                          _c(
                                            "strong",
                                            { staticClass: "text-danger" },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "Fecha y hora planificada"
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Tipo actividad:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      options: _vm.inputs.activityType.options,
                                      size: "sm",
                                      name: "Tipo actividad"
                                    },
                                    model: {
                                      value: _vm.inputs.activityType.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.inputs.activityType,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "inputs.activityType.value"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Tipo actividad"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 2 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Resultado:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.inputs.status.value === 3
                                            ? "required"
                                            : "",
                                        expression:
                                          "(inputs.status.value === 3) ? 'required':''"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      options: _vm.inputs.result.options,
                                      size: "sm",
                                      name: "Resultado"
                                    },
                                    model: {
                                      value: _vm.inputs.result.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.inputs.result,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "inputs.result.value"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Resultado"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Observaciones:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.ObsValidate,
                                        expression: "ObsValidate"
                                      }
                                    ],
                                    staticClass: "mb-3",
                                    attrs: {
                                      rows: 4,
                                      size: "sm",
                                      name: "Observaciones"
                                    },
                                    model: {
                                      value: _vm.inputs.comments,
                                      callback: function($$v) {
                                        _vm.$set(_vm.inputs, "comments", $$v)
                                      },
                                      expression: "inputs.comments"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Observaciones"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "exampleInputGroup1",
                                    label: "Invitados:",
                                    "label-for": "exampleInput1",
                                    description: ""
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "mb-3",
                                    attrs: {
                                      rows: 2,
                                      size: "sm",
                                      name: "Invitados"
                                    },
                                    model: {
                                      value: _vm.inputs.guests,
                                      callback: function($$v) {
                                        _vm.$set(_vm.inputs, "guests", $$v)
                                      },
                                      expression: "inputs.guests"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: 4 } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mt-32",
                                  attrs: { id: "exampleInputGroup1" }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_top",
                                        href: _vm.sendEmailGuests
                                      }
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "default"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "p-0 fa fa-envelope"
                                          }),
                                          _vm._v(
                                            "  Enviar correo a invitados\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "secondary" },
                                  on: { click: _vm.goBackDetails }
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: { click: _vm.saveNewVisit }
                                },
                                [_vm._v("Guardar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              _c("h3", [_vm._v("Nueva Entidad")]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Código" }
                            },
                            [
                              _c("b-form-input", {
                                model: {
                                  value: _vm.newEntity.codigo_entidad,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newEntity,
                                      "codigo_entidad",
                                      $$v
                                    )
                                  },
                                  expression: "newEntity.codigo_entidad"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Nombre" }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: { name: "Nombre" },
                                model: {
                                  value: _vm.newEntity.nombre_entidad,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newEntity,
                                      "nombre_entidad",
                                      $$v
                                    )
                                  },
                                  expression: "newEntity.nombre_entidad"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errors.first("Nombre")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Tipo" }
                            },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "mb-3",
                                attrs: {
                                  name: "Tipo",
                                  "text-field": "descripcion",
                                  "value-field": "id",
                                  options: _vm.tipo_entidad_options,
                                  disabled:
                                    _vm.tipo_entidad_options.length === 0
                                },
                                model: {
                                  value: _vm.newEntity.id_tipo_entidad,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newEntity,
                                      "id_tipo_entidad",
                                      $$v
                                    )
                                  },
                                  expression: "newEntity.id_tipo_entidad"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errors.first("Tipo")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Dato contacto" }
                            },
                            [
                              _c("b-form-input", {
                                model: {
                                  value: _vm.newEntity.datos_contacto,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.newEntity,
                                      "datos_contacto",
                                      $$v
                                    )
                                  },
                                  expression: "newEntity.datos_contacto"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "Dirección" }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: { name: "Dirección" },
                                model: {
                                  value: _vm.newEntity.direccion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newEntity, "direccion", $$v)
                                  },
                                  expression: "newEntity.direccion"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errors.first("Dirección")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticStyle: { "font-size": "1rem" },
                              attrs: { label: "CIF" }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: { name: "CIF" },
                                model: {
                                  value: _vm.newEntity.cif,
                                  callback: function($$v) {
                                    _vm.$set(_vm.newEntity, "cif", $$v)
                                  },
                                  expression: "newEntity.cif"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "error" }, [
                                _vm._v(_vm._s(_vm.errors.first("CIF")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.EntityForm = false
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.saveEntity }
                        },
                        [_vm._v("Guardar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _vm.showAlert
        ? _c(
            "div",
            { staticClass: "div-full" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "alert-class",
                  attrs: { show: "", dismissible: "", variant: "primary" },
                  on: {
                    dismissed: function($event) {
                      _vm.showAlert = false
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.alertText) + "\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisitsEntitiesResultsNew.vue?vue&type=template&id=0110fa05&scoped=true&
// module id = null
// module chunks = 